import clsx from "clsx";
import React, { FC } from "react";

import Add from "~/components/Icons/icon-add";

import s from "~/features/LicenseActionsModals/LicenseActionsModals.less";

interface AddEntityLinkProps {
  onClick: () => void;
  disabled?: boolean;
}

const AddEntityLink: FC<AddEntityLinkProps> = ({
  onClick,
  disabled,
  children,
}) => (
  <button
    type="button"
    className={clsx(s.addLink, { [s.addLinkDisabled]: disabled })}
    onClick={disabled ? undefined : onClick}
  >
    <span className={s.addLinkIcon}>
      <Add fill={disabled ? "#848E98" : "#E37639"} />
    </span>
    <span>{children}</span>
  </button>
);

export default AddEntityLink;
